import { render, staticRenderFns } from "./ThankYouTemplate.vue?vue&type=template&id=b7cd0af6&"
import script from "./ThankYouTemplate.vue?vue&type=script&lang=ts&"
export * from "./ThankYouTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports